// Export "PDF" d'un tableau d'historique de suivi : ouvre une fenetre d'impression (meme mecanique
// que PrintButton -> l'utilisateur enregistre en PDF via le dialogue navigateur, zero dependance).
// Le document porte le titre, la mention "Imprime par <user> le <date> a <heure>", et le tableau
// (Date / Operateur / Action / Description) identique aux onglets Historique des suivis.

export interface HistoriquePdfRow {
  created_at?: string | null;
  operateur?: string | null;
  prefix?: string | null;
  label?: string | null;
}

const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));

const formatDateHeure = (iso?: string | null): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const exportHistoriquePdf = (
  rows: HistoriquePdfRow[],
  title = 'Historique',
  printedBy?: string,
): void => {
  const now = new Date();
  const impression = now.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  const meta = printedBy
    ? `Imprimé par ${escapeHtml(printedBy)} le ${escapeHtml(impression)}`
    : `Imprimé le ${escapeHtml(impression)}`;

  const corps = rows
    .map(
      (r) => `
        <tr>
          <td>${escapeHtml(formatDateHeure(r.created_at))}</td>
          <td>${escapeHtml(r.operateur || '-')}</td>
          <td>${escapeHtml(r.prefix || '-')}</td>
          <td>${escapeHtml(r.label || '-')}</td>
        </tr>`,
    )
    .join('');

  const html = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; color: #2c3948; margin: 0; padding: 24px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    h1 { font-size: 18px; margin: 0 0 4px; color: #595959; }
    .meta { font-size: 12px; color: #6b7280; margin-bottom: 18px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th, td { border: 1px solid #d1d5db; padding: 8px 10px; text-align: left; vertical-align: top; }
    th { background: #f3f4f6; font-weight: 600; }
    tr:nth-child(even) td { background: #fafafa; }
    .empty { color: #6b7280; font-style: italic; }
    @media print { @page { margin: 16mm; } }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  <div class="meta">${meta}</div>
  <table>
    <thead>
      <tr><th>Date</th><th>Opérateur</th><th>Action</th><th>Description</th></tr>
    </thead>
    <tbody>
      ${corps || '<tr><td class="empty" colspan="4">Aucun historique disponible</td></tr>'}
    </tbody>
  </table>
  <script>window.onload = function () { window.focus(); window.print(); };</script>
</body>
</html>`;

  const printWindow = window.open('', '_blank');
  if (!printWindow) return;
  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
};
